import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";  // React Router imports
import { faFileLines, faUser, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
// import Tab from "./Tab";  // Ensure this component is available and correctly imported
import { getUserDetails } from "../utilities/get-user-details-from-cokies"; // Adjust import path
import Tab from "./Tab";

const SideNav = () => {
  const navigate = useNavigate();  // Use `useNavigate` instead of `history.push()`
  const location = useLocation();
  const currentUrl = location.pathname.split("/");  // Get current URL path segments

  const [userData, setUserData] = useState({});

  useEffect(() => {
    const userDetails = getUserDetails();  // Get user details from cookies or storage
    if (userDetails) {
      setUserData(userDetails);
    } else {
      navigate("/");  // Redirect to login if no user data
    }
  }, [navigate]);  // Make sure to include `navigate` as a dependency

  return (
    <>
      <div className="side_nav col">
        <div className="logo row-1">
          <img
            src="/assets/images/logo/NewLogo.png" // Ensure the path is correct
            width={130}
            height={60}
            alt="logo"
            loading="lazy"
          />
        </div>

        <div className="tab_list row-11">
          {/* {(userData.userType === "admin" || userData.userType === "owner") && ( */}
            <Tab
              tabName="Incubation Forms"
              icon={faUser}
              className={currentUrl[2] === "user-management" ? "active" : "tab_wrapper"}
              url="/main-panel/user-management"
            />
          {/* )} */}
          {/* Uncomment the following block if needed */}
          {/* {userData.userType === "admin" && ( 
            <Tab
              tabName="Project Management"
              icon={faFileLines}
              className={currentUrl[2] === "project-management" ? "active" : "tab_wrapper"}
              url="/main-panel/project-management"
            />
          )} */}
          
          {/* Uncomment and update paths as needed */}
          {/* {userData.userType !== "district user" && (
            <div
              onClick={() => navigate("/main-panel/complaint")}
              className="tab_wrapper_img"
            >
              <div className="icon_wrapper">
                <img
                  src={complaintIcon}  // Ensure this image is properly imported
                  className={currentUrl[2] === "complaint" ? "active" : "tab_wrapper"}
                  height={1}
                  width={1}
                  alt="Complaint"
                />
              </div>
              <Tab tabName="Complaint" />
            </div>
          )} */}
          
          <Tab
            tabName="Announcement"
            icon={faTriangleExclamation}
            className={currentUrl[2] === "complaint" ? "active" : "tab_wrapper"}
            url="/main-panel/complaint"
          />
        </div>
      </div>
    </>
  );
};

export default SideNav;
